import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { CleanFilterBtn } from '../doc-lib-components/Views/Filters-styles';
import { useTranslation } from 'react-i18next';
import EventsSearchContext from '../../../application/Context/EventsSearchContext';
export var CleanFilters = function () {
    var _a = React.useContext(EventsSearchContext), resetFilters = _a.resetFilters, filtersIsLoading = _a.filtersIsLoading;
    var t = useTranslation(['news']).t;
    return (!filtersIsLoading ? _jsxs(CleanFilterBtn, { onClick: resetFilters, children: [" ", t("Effacer les filtres")] }) : _jsx("div", { className: "spinner-border spinner-border-sm", role: "status" }));
};
